import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { blueGrey } from "@material-ui/core/colors";
import Check from "@material-ui/icons/Check";

import { getPropBtnByStatus } from "../../views/components/OrderActions";

import { updateOrderStatus } from "../../state/order/actions";

import { useDispatch, useSelector } from "react-redux";
import { StorageUser } from "../../main/StorageUser";

import Authorization from "./Authorization";

const useStyles = makeStyles(() => ({
  contentTitle: {
    color: "#FF0000",
    fontWeight: 400,
    textAlign: "center",
    textTransform: "uppercase",
    fontSize: "18px",
    margin: 0,
  },
  contentText: {
    fontSize: "18px",
    textAlign: "center",
    marginTop: 10,
    fontWeight: 700,
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid #EEE",
    border: "none",
  },
  dialogActions: {
    justifyContent: "space-between",
    padding: "8px 24px 16px",
  },
  button: {
    backgroundColor: blueGrey[900],
    color: "#fff",
    "&:hover": {
      backgroundColor: blueGrey[800],
    },
  },
}));

export default function ConfirmarRecebimentoModal(props) {
  const {
    open,
    handleClose,
    numero,
    status,
    origem,
    codigoExterno,
    setRefreshes,
  } = props;

  const classes = useStyles();
  const dispatch = useDispatch();

  const [openModal, setOpenModal] = useState(open);

  const nextStatus = getPropBtnByStatus(status).nextStatus;

  const storageUser = new StorageUser();

  const requireAutorizador = storageUser.allowedByPermission(
    "INLINE_CANCEL_CONFIRM"
  );

  const handleSubmit = async ({ nomeAutorizador, emailAutorizador } = {}) => {
    const orderStatus = {
      numero,
      status: nextStatus,
      origem,
      codigoExterno: codigoExterno && codigoExterno.split("#")[0],
      nomeAutorizador,
      emailAutorizador,
    };
    setOpenModal(false);

    await dispatch(updateOrderStatus(orderStatus));
    setRefreshes((refreshes) => refreshes + 1);
  };

  useEffect(() => {
    setOpenModal(open);
  }, [open]);

  return (
    <Dialog
      className={classes.dialog}
      open={openModal}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogContent style={{ overflow: "hidden" }}>
        <p className={classes.contentTitle}>Atenção!</p>

        <p className={classes.contentText}>
          Tem certeza que quer confirmar recebimento?
        </p>
      </DialogContent>

      <hr className={classes.hr} />

      {requireAutorizador && (
        <Authorization
          action={handleSubmit}
          cancel={handleClose}
          cancelText="Fechar"
          actionText="Sim"
          endIcon={<Check />}
        />
      )}

      {!requireAutorizador && (
        <DialogActions className={classes.dialogActions}>
          <Button onClick={handleClose} variant="outlined">
            Fechar
          </Button>
          <Button
            onClick={() => handleSubmit()}
            variant="contained"
            className={classes.button}
            endIcon={<Check />}
          >
            Sim
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
